import store from '@js/store';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account.vue'),
    },
    {
        path: '/plans',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account-subscribe.vue'),
        beforeEnter: (to, from, next) => {
            if (store.hasModule('myaccount')) {
                if (
                    store.getters['myaccount/hasSubscription'] &&
                    (store.getters['myaccount/statusIsInTrial'] ||
                        store.getters['myaccount/trialIsExpired'])
                ) {
                    return next();
                }
            }

            return next('/');
        },
    },
    {
        path: '/update-subscription',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account-update-plan.vue'),
        beforeEnter: (to, from, next) => {
            if (store.hasModule('myaccount')) {
                if (
                    store.getters['myaccount/hasSubscription'] &&
                    store.getters['myaccount/statusIsActive'] &&
                    !store.getters['myaccount/isCurrentTermEnded']
                ) {
                    return next();
                }
            }

            return next('/');
        },
    },
    {
        path: '/billing-history',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account-billing.vue'),
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/route-components/myaccount.js